// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__237IM","tab":"ProcedureTabs_tab__2LNvs"};